import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import axiosInstance from "Axiosinstance";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  ModalFooter,
  NavItem,
  NavLink,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import MiniWidget from "../Dashboard/mini-widget";
import { Formik, Field, Form, ErrorMessage } from "formik";
// import * as Yup from "yup";
import Select from "react-select";
import MuiPhoneNumber from "material-ui-phone-number";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateAdmins = () => {
  // STATES
  const [reports, setReports] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingPass, setIsEditingPass] = useState(false);
  const [accountType, setAccountType] = useState("admin");
  const [activeTab, setActiveTab] = useState("tag8");
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phone: "",
    countryCode: "",
    accessPermission: [],
  });
  const [userPhoneNo, setUserPhoneNo] = useState("");
  const [userPhoneCountryCode, setUserPhoneCountryCode] = useState("");
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [deletingAdminEmail, setDeletingAdminEmail] = useState("");
  const [editingAdminEmail, setEditingAdminEmail] = useState("");

  // FUNCTIONS
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
    setIsEditing(false);
    setIsEditingPass(false);
    setAccountType("admin");
    setUser({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      phone: "",
      countryCode: "",
      accessPermission: [],
    });
    setSelectedOptions([]);
    setSelectedAccessPerminssion([]);
    setUserPhoneNo("");
    setEditingAdminEmail("");
  };
  const editModalOpen = user => {
    setAccountType(user?.role === "partner" ? "partner" : "admin");
    setUser({
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      phone: user.phone,
      countryCode: user.phonecountrycode,
      accessPermission: user.activitiesAccess,
    });
    setUserPhoneNo(user.phone);
    setUserPhoneCountryCode(user.phonecountrycode);
    setSelectedOptions(
      user.activitiesAccess.map(item => {
        return {
          value: item,
          label: item,
        };
      })
    );
    setSelectedAccessPerminssion(user.activitiesAccess);
    setEditingAdminEmail(user.email);
    setIsEditing(true);
    setIsOpenModal(!isOpenModal);
  };
  const editPasswordModalOpen = user => {
    setAccountType(user?.role === "partner" ? "partner" : "admin");
    setUser({
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      phone: user.phone,
      countryCode: user.phonecountrycode,
      accessPermission: user.activitiesAccess,
    });
    setUserPhoneNo(user.phone);
    setUserPhoneCountryCode(user.phonecountrycode);
    setSelectedOptions(
      user.activitiesAccess.map(item => {
        return {
          value: item,
          label: item,
        };
      })
    );
    setSelectedAccessPerminssion(user.activitiesAccess);
    setEditingAdminEmail(user.email);
    setIsEditingPass(true);
    setIsOpenModal(!isOpenModal);
  };
  const openMadalToAddAdmin = () => {
    setAccountType("admin");
    setIsOpenModal(true);
  };
  const openModalToAddPartner = () => {
    setAccountType("partner");
    setIsOpenModal(true);
  };

  const toggleDeleteModal = () => {
    setIsOpenDeleteModal(!isOpenDeleteModal);
    setDeletingAdminEmail("");
  };
  const onDeleteUserAlert = email => {
    setIsOpenDeleteModal(!isOpenDeleteModal);
    setDeletingAdminEmail(email);
  };
  const handleUserDelete = async () => {
    const { data } = await axiosInstance.post(
      `/api/deleteCRMAdmin/${deletingAdminEmail}`
    );
    console.log("data: ", data);
    if (!data?.isError) {
      toast.success(data?.msg, {
        position: "top-center",
      });
      window.location.reload();
    } else if (data?.isError) {
      toast.error(data?.msg, {
        position: "top-center",
      });
    }
  };
  useEffect(() => {
    const fetchAdminsData = async () => {
      const { data } = await axiosInstance.post(`/api/getAllAdmins`);
      setAdmins(data?.data);
      setReports([
        {
          icon: "bx bx-copy-alt",
          title: "All Admins",
          value: data?.totalCount?.toString(),
          badgeValue: "+ 0.2%",
          color: "success",
          desc: "Total Number of Admins",
        },
      ]);
    };
    fetchAdminsData();
  }, []);

  const contactListColumns = [
    {
      text: "Id",
      dataField: "uid",
      sort: true,
      // hidden: true,
      formatter: (cellContent, user) => <>{user.uid}</>,
    },
    {
      text: "Name",
      dataField: "first_name",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.first_name}
            </Link>
          </h5>
        </>
      ),
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: (cellContent, user) => (
        <span className={`${user.isVerify === "0" ? "text-red" : ""}`}>
          {user.email}
        </span>
      ),
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "createDate",
      text: "Created On",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {new Date(user.date).toLocaleDateString()}
            </Link>
          </h5>
        </>
      ),
    },
    {
      text: "Created By", // Add this new column
      dataField: "created_by",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            {user.created_by ? user.created_by : "N/A"}
          </h5>
        </>
      ),
    },
    // {
    //   dataField: "uid",
    //   text: "UID",
    //   formatter: (cell) => cell || "N/A",
    // },
    {
      dataField: "modified_by",
      text: "Modified By",
      formatter: (cell) => cell || "N/A",
    },
    {
      dataField: "modified_date",
      text: "Modified Date",
      formatter: (cell, row) => {
        // console.log(row, "row");
        let date = cell || row.date;
        if (!date) return "N/A";
        // const date = new Date(cell);
        // console.log(date);
        const formattedDate = new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        return isNaN(new Date(date).getTime()) ? "Invalid Date" : formattedDate;
      },
    },
    {
      dataField: "menu",
      // isDummyField: true,
      editable: false,
      text: "Access Permissions",
      formatter: (cellContent, user) => {
        const isSuperadmin = user?.role === "superadmin";
        const isPartner = user?.role === "partner";

        return (
          <div className="d-flex gap-3 flex-wrap align-items-start">
            {isSuperadmin ? (
              <h5
                className="font-size-14 mb-1"
                style={{ color: "green", fontWeight: "bold" }}
              >
                Superadmin
              </h5>
            ) : (
              <div>
                {isPartner && (
                  <span
                    className="badge font-size-12 mb-2"
                    style={{ backgroundColor: "#0ea5e9", color: "#fff" }}
                  >
                    Company User
                  </span>
                )}
                {user?.activitiesAccess?.map(item => {
                  return (
                    <h5 key={item} className="font-size-12 m-1">
                      {item}
                    </h5>
                  );
                })}
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Actions",
      formatter: (cellContent, user) => (
        <div className="d-flex gap-2">
          <i
            className="mdi mdi-pencil font-size-18 text-success"
            style={{ cursor: "pointer" }}
            id="edittooltip"
            onClick={() => editModalOpen(user)}
          ></i>

          <i
            className="mdi mdi-lock-reset font-size-20 text-info"
            style={{ cursor: "pointer" }}
            id="edittooltip"
            onClick={() => {
              editPasswordModalOpen(user);
            }}
          ></i>
          <i
            className="mdi mdi-delete font-size-18 text-danger"
            style={{ cursor: "pointer" }}
            id="edittooltip"
            onClick={() => onDeleteUserAlert(user.email)}
          ></i>
        </div>
      ),
    },
  ];

  const tag8Users = admins?.filter(user => user?.role !== "partner") || [];
  const companyUsers = admins?.filter(user => user?.role === "partner") || [];
  const filteredAdmins = activeTab === "company" ? companyUsers : tag8Users;

  const pageOptions = {
    sizePerPage: 20,
    totalSize: filteredAdmins?.length,
    custom: true,
  };

  const options = [
    { value: "User Management", label: "User Management" },
    { value: "Tag Management", label: "Tag Management" },
    { value: "Dispatch Management", label: "Dispatch Management" },
    { value: "LNF Management", label: "LNF Management" },
    { value: "Return Management", label: "Return Management" },
    {
      value: "MAC Address Pairing Management",
      label: "MAC Address Pairing Management",
    },
    // { value: "Coupon Management", label: "Coupon Management" },
    { value: "Tag Generation Management", label: "Tag Generation Management" },
    { value: "Billing Management", label: "Billing Management" },
    { value: "Visualization Management", label: "Visualization Management" },
  ];
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedAccessPerminssion, setSelectedAccessPerminssion] = useState(
    []
  );
  const SelectField = ({ options, field, form, isDisabled }) => {
    return (
      <Select
        options={options}
        isMulti
        isDisabled={isDisabled}
        name={field.name}
        value={selectedOptions}
        onChange={option => {
          setSelectedOptions(option);
          const values = option.map(item => item.value);
          form.setFieldValue(field.name, values);
          setSelectedAccessPerminssion(values);
        }}
        onBlur={() => form.setFieldTouched(field.name, true)}
      />
    );
  };
  // console.log("showingAccess: ", showingAccess);
  return (
    <>
      <div className="page-content">
        {/* DB CArds */}
        <Row>
          <Col xl="12">
            <Row>
              <MiniWidget reports={reports} />
            </Row>
          </Col>
        </Row>

        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Admins" breadcrumbItem="Admins List" />
          <Row>
            <Col lg="12">
                <Card>
                <CardBody>
                  <ul className="nav nav-tabs nav-tabs-custom">
                    <NavItem>
                      <NavLink
                        className={activeTab === "tag8" ? "active" : ""}
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveTab("tag8")}
                      >
                        Tag8 User
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTab === "company" ? "active" : ""}
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveTab("company")}
                      >
                        Company User
                      </NavLink>
                    </NavItem>
                  </ul>
                  <div className="mt-4">
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="uid"
                      columns={contactListColumns}
                      data={filteredAdmins}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="uid"
                          columns={contactListColumns}
                          data={filteredAdmins}
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-3 justify-content-end">
                                <Col sm="12">
                                  <div className="d-flex justify-content-sm-end flex-wrap gap-2">
                                    <Button
                                      color="primary"
                                      className="font-16 btn btn-primary px-4 shadow-sm"
                                      onClick={openMadalToAddAdmin}
                                      style={{
                                        borderRadius: "999px",
                                        minWidth: "160px",
                                      }}
                                    >
                                      Create Tag8 User
                                    </Button>
                                    <Button
                                      onClick={openModalToAddPartner}
                                      className="font-16 btn px-4 text-white border-0 shadow-sm"
                                      style={{
                                        borderRadius: "999px",
                                        minWidth: "190px",
                                        background:
                                          "linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)",
                                      }}
                                    >
                                      Create Company User
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ADD & EDIT Admin Modal */}
      <Modal isOpen={isOpenModal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal} tag="h4">
          {!!isEditing
            ? accountType === "partner"
              ? "Edit Company User"
              : "Edit Tag8 User"
            : isEditingPass
            ? "Edit Password"
            : accountType === "partner"
            ? "Add Company User"
            : "Add Tag8 User"}
        </ModalHeader>
        <ModalBody>
          <Formik
            enableReinitialize={true}
            initialValues={{
              firstName: (user && user.firstName) || "",
              lastName: (user && user.lastName) || "",
              email: (user && user.email) || "",
              password: (user && user.password) || "",
              phone: (user && user.phone) || "",
              countryCode: (user && user.countryCode) || "",
              accessPermission: (user && user.accessPermission) || [],
            }}
            onSubmit={async values => {
              if (isEditing) {
                // console.log("isEditing values: ", values);
                values.countryCode = userPhoneCountryCode;
                values.phone = userPhoneNo;
                if (
                  !values.firstName ||
                  !values.lastName ||
                  !values.phone ||
                  !values.email ||
                  !values.countryCode
                ) {
                  toast.error("Incomple Parameters !", {
                    position: "top-center",
                  });
                  if (accountType !== "partner" && !values.accessPermission.length) {
                    toast.error("Access Permission is required !", {
                      position: "top-center",
                    });
                  }
                } else {
                  const { data } = await axiosInstance.post(
                    `/api/updateCRMAdmin/${editingAdminEmail}`,
                    values
                  );
                  console.log("data: ", data);
                  if (!data?.isError) {
                    toast.success(data?.msg, {
                      position: "top-center",
                    });
                    window.location.reload();
                  } else if (data?.isError) {
                    toast.error(data?.msg, {
                      position: "top-center",
                    });
                  }
                }
              } else if (isEditingPass) {
                // console.log("isEditing values: ", values);
                values.countryCode = userPhoneCountryCode;
                values.phone = userPhoneNo;
                if (!values.email || !values.password) {
                  toast.error("Incomple Parameters !", {
                    position: "top-center",
                  });
                } else {
                  const { data } = await axiosInstance.post(
                    `/api/updatePasswordCRMAdmin/${editingAdminEmail}`,
                    { newPassword: values.password }
                  );
                  console.log("data: ", data);
                  if (!data?.isError) {
                    toast.success(data?.msg, {
                      position: "top-center",
                    });
                    window.location.reload();
                  } else if (data?.isError) {
                    toast.error(data?.msg, {
                      position: "top-center",
                    });
                  }
                }
              } else {
                values.countryCode = userPhoneCountryCode;
                values.phone = userPhoneNo;
                values.accessPermission =
                  accountType === "partner" ? [] : selectedAccessPerminssion;
                values.type = accountType;
                if (
                  !values.firstName ||
                  !values.lastName ||
                  !values.phone ||
                  !values.email ||
                  !values.countryCode ||
                  (accountType !== "partner" &&
                    !values.accessPermission.length) ||
                  !values.password
                ) {
                  toast.error("Incomple Parameters !", {
                    position: "top-center",
                  });
                } else {
                  const { data } = await axiosInstance.post(
                    `/api/createCRMAdminDetails`,
                    values
                  );
                  console.log("data: ", data);
                  if (!data?.isError) {
                    toast.success(data?.status, {
                      position: "top-center",
                    });
                    window.location.reload();
                  } else if (data?.isError) {
                    toast.error(data?.error, {
                      position: "top-center",
                    });
                  }
                }
              }
            }}
          >
            {({ errors, status, touched }) => (
              <Form>
                <Row>
                  <Col className="col-12">
                    {!isEditingPass && (
                      <>
                        <div className="mb-3">
                          <Label className="form-label">First Name</Label>
                          <Field
                            name="firstName"
                            type="text"
                            className={
                              "form-control" +
                              (errors.firstName && touched.firstName
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="firstName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Last Name</Label>
                          <Field
                            name="lastName"
                            type="text"
                            className={
                              "form-control" +
                              (errors.lastName && touched.lastName
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="lastName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Phone</Label>
                          <MuiPhoneNumber
                            placeholder="Phone"
                            name="phone"
                            className={
                              "form-control" +
                              (errors.phone && touched.phone
                                ? " is-invalid"
                                : "")
                            }
                            defaultCountry={"in"}
                            value={`${userPhoneCountryCode} ${userPhoneNo}`}
                            onChange={value => {
                              const code = value?.split(" ")[0];
                              setUserPhoneCountryCode(code);
                              setUserPhoneNo(value?.slice(code?.length).trim());
                            }}
                          />
                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <div className="mb-3">
                         
                          {
                            accountType !== "partner" && <>
                             <Label className="form-label">
                            Access Permission
                          </Label>
                             <Field
                            component={SelectField}
                            name="accessPermission"
                            options={options}
                            isDisabled={accountType === "partner"}
                          />
                                   <ErrorMessage
                            name="accessPermission"
                            component="div"
                            className="invalid-feedback"
                          />
                          </>
                          }
                         
                 
                        </div>
                      </>
                    )}
                    {/* email */}
                    <div className="mb-3">
                      <Label className="form-label">Email</Label>
                      <Field
                        name="email"
                        type="text"
                        className={
                          "form-control" +
                          (errors.email && touched.email ? " is-invalid" : "")
                        }
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                    {!isEditing ? (
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Field
                          name="password"
                          type="password"
                          className={
                            "form-control" +
                            (errors.password && touched.password
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>

      {/* Delete amdin modal */}
      <Modal isOpen={isOpenDeleteModal} fade={false} toggle={toggleDeleteModal}>
        <ModalHeader>Are you sure? You want to detele.</ModalHeader>
        <ModalFooter>
          <Button color="primary" onClick={handleUserDelete}>
            Delete
          </Button>{" "}
          <Button color="secondary" onClick={toggleDeleteModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* TOAST NOTIFICATIONS */}
      <ToastContainer />
    </>
  );
};

export default CreateAdmins;
